import React, { type ReactNode } from 'react';
import { styled as styled2 } from '@compiled/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled, { css } from 'styled-components';
import { token } from '@atlaskit/tokens';
import type { QuickstartNudgeContainerComponentProps } from '@atlassian/jira-onboarding-quickstart-core/src/common/ui/quickstart-nudge/types';

const NoCSSOverrides = css({});
const UnderlineFriendlyInsideMenu = NoCSSOverrides;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const UnderlineFriendlyOutsideMenu = css`
	& > span {
		display: inline;
	}
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any,  @atlaskit/design-system/no-css-tagged-template-expression
const UnderlineFriendlyStyles = css<any>`
	${({ isInsideMenu }) =>
		isInsideMenu ? UnderlineFriendlyInsideMenu : UnderlineFriendlyOutsideMenu}
`;

const NudgeFriendlyStylesInsideMenu = NoCSSOverrides;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const NudgeFriendlyStylesOutsideMenu = css({
	display: 'flex',
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const NudgeFriendlyStylesOutsideMenuNew =
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
	styled2.div<QuickstartNudgeContainerComponentProps>({
		display: 'flex',
		alignItems: 'center',
	});

// eslint-disable-next-line @typescript-eslint/no-explicit-any,  @atlaskit/design-system/no-css-tagged-template-expression
const NudgeFriendlyStyles = css<any>`
	${({ isInsideMenu }) =>
		isInsideMenu ? NudgeFriendlyStylesInsideMenu : NudgeFriendlyStylesOutsideMenu}
`;

// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line  @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const NavigationItemContainer = styled.div<{ isHidden: boolean }>`
	${({ isHidden }) => (isHidden ? UnderlineFriendlyStyles : NudgeFriendlyStyles)}
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FormNudgeWrapper = styled2.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'& > span': {
		height: '100%',
		width: `calc(100% - ${token('space.100', '8px')})`,
		marginInline: token('space.050', '4px'),
	},
});

export const CreateColumnContainer = ({
	children,
	isHidden,
}: {
	children: ReactNode;
	isHidden: boolean;
}) =>
	isHidden ? (
		<CreateColumnContainerHidden>{children}</CreateColumnContainerHidden>
	) : (
		<CreateColumnContainerNonHidden>{children}</CreateColumnContainerNonHidden>
	);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const CreateColumnContainerNonHidden = styled2.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'& > span': {
		paddingLeft: token('space.075', '6px'),
		paddingRight: token('space.150', '12px'),
		marginTop: token('space.025', '4px'),
		position: 'sticky',
		top: token('space.025', '4px'),
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'& > div': {
			paddingInline: token('space.0', '0px'),
		},
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const CreateColumnContainerHidden = styled2.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'& > span': {
		height: '100%',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'& > div': {
			height: '100%',
		},
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
		'& > div::before': {
			transition: 'none',
		},
	},
});
